if (!customElements.get('video-banner')) {
  customElements.define('video-banner', class VideoBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      console.log('video-banner');
      //this.loadYouTubeVideos();
      var tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    loadYouTubeVideos() {
      this.wrapper = this.querySelector('.video-banner__media-container');
      this.placeholder = this.querySelector('.video-banner__placeholder');
      let _this = this;
      let player = new YT.Player(_this.placeholder.id, {
        width: 1280,
        height: 720,
        videoId: this.placeholder.dataset.videoId,
        playerVars: {
          autoplay: 1,
          autohide: 0,
          branding: 0,
          cc_load_policy: 0,
          controls: 0,
          fs: 0,
          loop: 1,
          playlist: _this.placeholder.dataset.videoId,
          iv_load_policy: 3,
          modestbranding: 1,
          playsinline: 1,
          quality: 'hd720',
          rel: 0,
          showinfo: 0,
          wmode: 'opaque'
        },
        events: {
          'onReady': _this.ytOnPlayerReady.bind(_this)
        }
      })
    }

    ytOnPlayerReady(evt) {
      let _this = this;
      setTimeout(function() {
        evt.target.mute();
        evt.target.playVideo();
        _this.querySelector('.video-banner__media-container').classList.add('loaded');
      }.bind(this), 1250);
    }

    loadVimeoVideos() {
    }

    loadMp4Videos() {
    }
  })
}

window.onYouTubeIframeAPIReady = function() {
  let banners = document.querySelectorAll('video-banner');
  for(var i=0; i<banners.length; i++) {
    banners[i].loadYouTubeVideos();
  }
}
